export default __webpack_public_path__ + "static/media/UserPerformance.66255796.svg";